import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { EntregaDeTrabalhoService } from '../../../services/EntregaDeTrabalho/EntregaDeTrabalhoService'

export interface IProps {
  isOpen: boolean
  onClose: () => void
  id?: number
  onDelete: () => void
  leastDestructiveRef: any
}

export function EntregaDeTrabalhoDeleteDialog({ isOpen, onClose, id, onDelete, leastDestructiveRef }: IProps) {
  const service = new EntregaDeTrabalhoService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    if (!id) return

    setIsLoading(true)
    try {
      await service.delete(id)

      toast({
        title: 'Entrega de Trabalho deletada',
        description: 'Entrega de Trabalho deletada com sucesso.',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onDelete()
      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao deletar a entrega de trabalho',
        description: 'Erro ao deletar a entrega de trabalho, tente novamente mais tarde.',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Deletar entrega de trabalho
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja deletar a entrega de trabalho?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Deletar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
